export default {
  banner_h1_early_stage: {
    en: 'Getting first traction through Cold Email',
    de: 'Erste Erfolge durch Kaltakquise-E-Mails erzielen',
  },

  banner_h2_early_stage: {
    en: 'We help early-stage founders find their first customers',
    de: 'Wir helfen Unternehmen, ihre ersten Kunden zu finden',
  },

  banner_h1_cold_email_marketing: {
    en: 'Build Cold Emails That Just Work',
    de: 'Erstelle Kaltakquise-E-Mails, die funktionieren',
  },

  banner_h2_cold_email_marketing: {
    en: 'Personalize and track your outreach with ease - all in one place',
    de: 'Personalisiere und verfolge deine E-Mails mit Leichtigkeit - alles an einem Ort',
  },

  banner_btn_1: {
    en: 'Start Growing Today',
    de: 'Starte dein Wachstum',
  },

  banner_btn_disclaimer: {
    en: 'No credit card required',
    de: 'Keine Kreditkarte erforderlich',
  },

  achievement_1: {
    en: 'and more saved per week',
    de: 'und mehr pro Woche gespart',
  },

  achievement_2: {
    en: 'more emails sent daily',
    de: 'mehr E-Mails versendet',
  },

  achievement_3: {
    en: 'replies with personalization',
    de: 'antwortrate mit Personalisierung',
  },

  achievement_disclaimer: {
    en: "Average feedback from our customers can vary depending on your industry and how much effort you're willing to put in.",
    de: 'Das Feedback von unseren Kunden kann je nach Branche und wie viel Aufwand du investierst, variieren.',
  },

  problem_category: {
    en: 'Problem',
    de: 'Problem',
  },

  problem_h2: {
    en: 'Why Cold Email?',
    de: 'Warum Kaltakquise per E-Mail?',
  },

  problem_p: {
    en: 'You are probably wondering why you should send emails to strangers in the first place. Is anyone going to read them? Why not just run paid ads or post in communities? Those are valid points. And you can do many things to get initial traction. But here are some points that benefit cold emails.',
    de: 'Du fragst dich wahrscheinlich, warum du überhaupt E-Mails an fremde Personen senden solltest. Wird sie überhaupt jemand lesen? Warum nicht einfach bezahlte Werbung schalten oder in Communities posten? Das sind berechtigte Fragen. Es gibt viele Möglichkeiten, um erste Aufmerksamkeit zu bekommen. Aber hier sind einige Punkte, die für Kaltakquise-E-Mails sprechen.',
  },

  problem_1_h: {
    en: 'It’s free',
    de: 'Es ist kostenlos',
  },

  problem_1_p: {
    en: 'Yes, it takes time, but once you know how to do it, you get very efficient at it. Money-wise, no investment is required to get started. And of course, we’ve got your back as well.',
    de: 'Ja, es kostet Zeit, aber sobald du weißt, wie es geht, wirst du sehr effizient darin. Finanziell gesehen ist keine Investition erforderlich, um loszulegen. Und natürlich unterstützen wir dich dabei.',
  },

  problem_2_h: {
    en: 'You are in control',
    de: 'Du hast die Kontrolle',
  },

  problem_2_p: {
    en: 'Compared to paid ads, you get to decide who you send the email to. Gaining insights into which industries read and reply are powerful insights.',
    de: 'Im Vergleich zu bezahlter Werbung entscheidest du selbst, wem du eine E-Mail sendest. Erkenntnisse darüber, welche Branchen lesen und antworten, sind sehr wertvoll.',
  },

  problem_3_h: {
    en: 'Emails are popular',
    de: 'E-Mails sind beliebt',
  },

  problem_3_p: {
    en: 'Among professionals and businesses, email is still the number one communication method. Businesses check their inboxes. You are good as long as you don’t end up in spam.',
    de: 'Für Fachleute und Unternehmen bleibt E-Mail das wichtigste Kommunikationsmittel. Solange du nicht im Spam landest, wirst du gesehen.',
  },

  problem_4_h: {
    en: 'Everybody does it',
    de: 'Alle machen es',
  },

  problem_4_p: {
    en: 'To some extent, all organizations communicate through email with their (potential) customers — sometimes better, sometimes worse. They call it marketing but are still hoping for a sale.',
    de: 'Bis zu einem gewissen Grad kommunizieren alle Organisationen per E-Mail mit ihren (potenziellen) Kunden – mal besser, mal schlechter. Sie nennen es Marketing, hoffen aber letztlich auf einen Verkauf.',
  },

  problem_5_h: {
    en: 'Scalability',
    de: 'Skalierbarkeit',
  },

  problem_5_p: {
    en: 'You can decide to send 20 cold emails a day, or you can decide to send thousands. We highly advise against spamming. But if you don know what you are doing, the possibility is there.',
    de: 'Du kannst entscheiden, ob du 20 Kaltakquise-E-Mails pro Tag verschickst oder Tausende. Wir raten dringend davon ab, zu spammen. Aber wenn du weißt, was du tust, besteht die Möglichkeit dazu.',
  },

  problem_6_h: {
    en: 'It’s faster',
    de: 'Es ist schneller',
  },

  problem_6_p: {
    en: 'There are other traction methods, for example, posting on social media or building an audience. While you can be highly successful with that, it sometimes takes months or years to grow your audience to a relevant size.',
    de: 'Es gibt auch andere Wege, etwa über Social Media. Damit kann man erfolgreich sein, aber es dauert oft Monate oder Jahre, bis man eine größere Zielgruppe erreicht.',
  },

  about_category: {
    en: 'About',
    de: 'Über',
  },

  about_h2: {
    en: 'How to do Cold Email?',
    de: 'Wie funktioniert Kaltakquise per E-Mail?',
  },

  about_p: {
    en: 'Now that we know cold emails can be a solution to traction issues, let’s look at some key points to consider when sending them. If you decide to send cold emails on your own, please still read this section. There are many things you can do wrong — we had to learn this the hard way.',
    de: 'Jetzt, da wir wissen, dass Kaltakquise-E-Mails eine Lösung für Anlaufprobleme sein können, schauen wir uns einige wichtige Punkte an, die beim Versenden zu beachten sind. Wenn du dich entscheidest, selbst Kaltakquise-E-Mails zu verschicken, lies diesen Abschnitt unbedingt. Es gibt viele Fehler, die man machen kann – wir mussten das auf die harte Tour lernen.',
  },

  about_1_head: {
    en: 'Warm up your email address',
    de: 'Wärme deine E-Mail-Adresse auf',
  },

  about_1_body: {
    en: 'Meaning: start small and manual. Sending ten to twenty emails a day while slowly increasing the volume over time will help you avoid spam folders.',
    de: 'Das bedeutet: Starte klein und manuell. Zehn bis zwanzig E-Mails pro Tag zu senden und das Volumen langsam zu steigern, hilft dir dabei, Spam-Ordner zu vermeiden.',
  },

  about_2_head: {
    en: 'Track your open rate',
    de: 'Verfolge deine Öffnungsrate',
  },

  about_2_body: {
    en: 'You want to know who is reading your email and must track when someone opens it. This way, you can A/B test your subject lines and make sure what you send is read. There are services, tutorials, and many other options out there. But you can also ask us or do it with arcticreply.',
    de: 'Du solltest wissen, wer deine E-Mail liest, und nachverfolgen, wann sie geöffnet wird. So kannst du deine Betreffzeilen per A/B-Test optimieren und sicherstellen, dass deine Nachrichten gelesen werden. Es gibt zahlreiche Dienste, Tutorials und andere Möglichkeiten dafür. Du kannst uns aber auch fragen oder es mit ArcticReply umsetzen.',
  },

  about_3_head: {
    en: 'Personalize your emails',
    de: 'Personalisiere deine E-Mails',
  },

  about_3_body: {
    en: 'Tailoring your email to the prospect is crucial. It shows that you thought about how you might add value to their business. Everyone can send out a generic sales pitch — but people do not reply to mass pitches. If they read your email, they want to be taken seriously.',
    de: 'Deine E-Mail individuell auf den Empfänger zuzuschneiden, ist entscheidend. Es zeigt, dass du dir Gedanken darüber gemacht hast, wie du ihrem Unternehmen einen Mehrwert bieten kannst. Jeder kann eine generische Verkaufsbotschaft verschicken – aber auf Massen-E-Mails antwortet kaum jemand. Wenn jemand deine E-Mail liest, möchte er ernst genommen werden.',
  },

  about_4_head: {
    en: 'Watch interaction',
    de: 'Achte auf Interaktionen',
  },

  about_4_body: {
    en: 'When someone sends you a positive reply (even if not a sale yet) or clicks on any links in your email, they become a “warm lead.” They showed some interest. You want to know who showed interest so you can retarget them after a little while (sometimes a few days, sometimes a few weeks).',
    de: 'Wenn dir jemand positiv antwortet (auch wenn noch kein Verkauf erfolgt ist) oder auf einen Link in deiner E-Mail klickt, wird er zu einem „warmen Lead“. Er hat Interesse gezeigt. Du solltest wissen, wer Interesse gezeigt hat, um ihn nach einiger Zeit erneut anzusprechen (manchmal nach ein paar Tagen, manchmal nach ein paar Wochen).',
  },

  about_5_head: {
    en: 'Patience',
    de: 'Geduld',
  },

  about_5_body: {
    en: 'Sending a hundred emails probably won’t give you the outcome you dreamed of. Sending 1,000 emails every month will at some point. Don’t get discouraged — it is a numbers game. And even if someone complains, stay polite and move on to the next email.',
    de: 'Hundert versendete E-Mails werden dir wahrscheinlich nicht das gewünschte Ergebnis bringen. Tausend E-Mails pro Monat jedoch irgendwann schon. Lass dich nicht entmutigen – es ist ein Zahlenspiel. Und selbst wenn sich jemand beschwert, bleibe höflich und mache einfach weiter.',
  },

  about_6_head: {
    en: 'Opt-out option',
    de: 'Abmeldemöglichkeit',
  },

  about_6_body: {
    en: 'As you are probably acting under some kind of data privacy law, it’s important to include a note that people can “unsubscribe” from your mailing if they wish to no longer be contacted. Respect that and build it into your email. Again, this is something we can help you with.',
    de: 'Da du vermutlich unter bestimmten Datenschutzgesetzen agierst, ist es wichtig, einen Hinweis einzubauen, dass sich Empfänger von deinem Verteiler abmelden können, wenn sie keine weiteren E-Mails wünschen. Respektiere diesen Wunsch und integriere die Abmeldemöglichkeit in deine E-Mail. Auch hierbei können wir dich unterstützen.',
  },

  about_7_head: {
    en: 'Target the right people',
    de: 'Ziel die richtigen Personen an',
  },

  about_7_body: {
    en: 'You probably have an idea who your dream customer is. That’s great. And if not, we recommend you test out different industries over a certain period. With the right tracking and opt-out options in place, these numbers give you good insight into who is interested in your business.',
    de: 'Du hast wahrscheinlich eine Vorstellung davon, wer dein Wunschkunde ist. Das ist großartig. Falls nicht, empfehlen wir dir, verschiedene Branchen über einen gewissen Zeitraum hinweg zu testen. Mit dem richtigen Tracking und eingebauten Abmeldemöglichkeiten bekommst du wertvolle Einblicke, wer sich für dein Angebot interessiert.',
  },

  solution_category: {
    en: 'Solution',
    de: 'Lösung',
  },

  solution_h2: {
    en: 'Why arcticreply?',
    de: 'Warum arcticreply?',
  },

  solution_p: {
    en: 'Now that we gathered the most important information (even though we barely scratched the surface), the question why you should use arcticreply still remains. While you could build and implement all of this on your own, here are a few things we can offer you.',
    de: 'Jetzt, da wir die wichtigsten Informationen gesammelt haben (auch wenn wir nur an der Oberfläche gekratzt haben), bleibt die Frage: Warum solltest du arcticreply nutzen? Du könntest all das auch selbst aufbauen und umsetzen, aber hier sind ein paar Dinge, die wir dir bieten können.',
  },

  solution_1_h: {
    en: 'Personalization',
    de: 'Personalisierung',
  },

  solution_1_p: {
    en: 'We believe in personalized emails (which is also supported by our data), and we want to help you with exactly this. We tailor the email automatically to each prospect you are sending it to. Don’t worry — you can edit everything before you send if you do not trust us.',
    de: 'Wir glauben an personalisierte E-Mails (unsere Daten bestätigen das) und helfen dir genau dabei. Jede E-Mail wird automatisch an den Empfänger angepasst – du kannst sie vor dem Senden prüfen und bearbeiten.',
  },

  solution_2_h: {
    en: 'Tracking & Automation',
    de: 'Tracking & Automatisierung',
  },

  solution_2_p: {
    en: 'We offer a history of emails you send and show you who opened the email. This way, you can see if our product is working. And if not, our technology improves with every email you send. This way, you can work on your actual product.',
    de: 'Du siehst, wer deine E-Mails geöffnet hat – und ob unser Produkt für dich funktioniert. Falls nicht: Unsere Technologie lernt mit jeder Mail. So kannst du dich auf dein Produkt konzentrieren.',
  },

  solution_3_h: {
    en: 'Experience',
    de: 'Erfahrung',
  },

  solution_3_p: {
    en: 'We do what we do because we know how hard it is to get initial traction. The world needs more founders who build something meaningful. Therefore, we collected our knowledge and put it into arcticreply.',
    de: 'Wir tun, was wir tun, weil wir wissen, wie schwer es ist, erste Erfolge zu erzielen. Die Welt braucht mehr Gründer, die etwas Sinnvolles aufbauen. Deshalb haben wir unser Wissen gesammelt und in arcticreply eingebracht.',
  },

  solution_4_h: {
    en: 'It’s free',
    de: 'Es ist kostenlos',
  },

  solution_4_p: {
    en: 'If nothing convinced you yet, maybe this will: up to 1,000 emails every month are free. We want to help you get started. And once you see the system working and have your first customers — great. Let’s get you on the paid plan and let you grow even faster.',
    de: 'Noch nicht überzeugt? Bis zu 1.000 E-Mails pro Monat sind kostenlos. Wir helfen dir beim Start. Sobald du siehst, dass es funktioniert und du deine ersten Kunden gewonnen hast, steigst du auf den kostenpflichtigen Plan und kannst noch schneller wachsen.',
  },

  generator_category: {
    en: 'Generate',
    de: 'Generieren',
  },

  generator_input_h2: {
    en: 'Sample Input',
    de: 'Beispieleingabe',
  },

  generator_input_p: {
    en: 'Try a simplified version of our software below. Just fill out the form and submit.',
    de: 'Teste eine vereinfachte Version unserer Software. Einfach das Formular ausfüllen und absenden.',
  },

  generator_input_placeholder: {
    en: 'Type in an Email, e.g. info@arcticreply.com',
    de: 'Gib eine E-Mail ein, z.B. info@arcticreply.com',
  },

  generator_input_label: {
    en: 'Recipient Email',
    de: 'Empfänger-E-Mail',
  },

  generator_textarea_placeholder: {
    en: 'e.g. Generate high-converting cold emails effortlessly with AI. Personalize, optimize, and boost your response rates in seconds.',
    de: 'z.B. Erstelle mühelos überzeugende Kaltakquise-E-Mails mit KI. Personalisiere, optimiere und steigere deine Antwortraten in Sekunden.',
  },

  generator_textarea_label: {
    en: 'Your Product Description',
    de: 'Deine Produktbeschreibung',
  },

  generator_output_h2: {
    en: 'Sample Output',
    de: 'Beispielausgabe',
  },

  invalid_email: {
    en: 'Invalid Email',
    de: 'Ungültige E-Mail',
  },

  Remaining: {
    en: 'Remaining',
    de: 'Verbleibend',
  },

  pricing_category: {
    en: 'Plans',
    de: 'Pläne',
  },

  pricing_h2: {
    en: 'Our subscription plans',
    de: 'Unsere Abo-Pläne',
  },

  pricing_p: {
    en: 'Here you can find our current offer. Available as a monthly or annual subscription.',
    de: 'Hier findest du unser aktuelles Angebot. Erhältlich als monatliches oder jährliches Abo.',
  },

  monthly: {
    en: 'Monthly',
    de: 'Monatlich',
  },

  annual: {
    en: 'Annual',
    de: 'Jährlich',
  },

  pricing_free_desc: {
    en: 'Perfect for all founders and startup looking for their first traction',
    de: 'Perfekt für alle Gründer und Startups, die ihre ersten Erfolge suchen',
  },

  pricing_starter_desc: {
    en: 'Perfect for small teams and individuals who are just starting out',
    de: 'Perfekt für kleine Teams und Einzelpersonen, die gerade erst anfangen',
  },

  plan_users: {
    en: 'Up to %r% Users',
    de: 'Bis zu %r% Nutzer',
  },

  plan_users_desc: {
    en: 'Users can be added and modified via the arcticreply platform.',
    de: 'Nutzer können über die arcticreply-Plattform hinzugefügt und bearbeitet werden.',
  },

  plan_generator_tokens: {
    en: ' %r% Generator Tokens per Month',
    de: '%r% Generator Token pro Monat',
  },

  plan_generator_tokens_desc: {
    en: 'One token is used per generated email, shared between users.',
    de: 'Ein Token, pro erstellter E-Mail, verteilt über alle Nutzer.',
  },

  plan_sending_tokens: {
    en: ' %r% E-Mail Tokens per Month',
    de: '%r% E-Mail Token pro Monat',
  },

  plan_sending_tokens_desc: {
    en: 'One token is used per send email, shared between users.',
    de: 'Ein Token, pro gesendeter E-Mail, verteilt über alle Nutzer.',
  },

  plan_mail_generator: {
    en: 'Mail generator',
    de: 'E-Mail generator',
  },

  plan_mail_generator_desc: {
    en: 'Create customized cold emails in the arcticreply portal.',
    de: 'Erstelle personalisierte Kaltakquise-E-Mails im arcticreply-Portal.',
  },

  plan_email_tracking: {
    en: 'Tracking functionality',
    de: 'Tracking',
  },

  plan_email_tracking_desc: {
    en: 'Email open and link clicks, if send through arcticreply.',
    de: 'E-Mail-Öffnungen und Link-Klicks, wenn die E-Mails über arcticreply versendet werden.',
  },

  plan_smtp: {
    en: 'Connect your Inboxes (%r%)',
    de: 'Postfach Verknüpfen (%r%)',
  },

  plan_smtp_desc: {
    en: 'Send emails through arcticreply with integration of your provider. Track replies and bounce rates.',
    de: 'Versende E-Mails über arcticreply mit der Integration deines Anbieters. Verfolge Antworten und Bounceraten.',
  },

  plan_api: {
    en: 'API access',
    de: 'API-Zugang',
  },

  plan_api_desc: {
    en: 'Integrate arcticreply in your environment',
    de: 'Integriere arcticreply in deine Umgebung.',
  },

  pricing_academy_description: {
    en: 'Perfect if you want to build your own system and need some expert advise',
    de: 'Perfekt, wenn du dein eigenes System aufbauen möchtest und Expertenrat benötigst.',
  },

  plan_implement: {
    en: 'Custom system',
    de: 'Individuelles System',
  },

  plan_implement_desc: {
    en: 'We will help you implement a cold email system into your environment. We will walk you through and guide you on every step of the process.',
    de: 'Wir helfen euch, ein Kaltakquise-E-Mail-System in eure Umgebung zu integrieren. Wir begleiten euch Schritt für Schritt durch den gesamten Prozess.',
  },

  plan_analyse: {
    en: 'Analyse & improve',
    de: 'Analysieren & Optimieren',
  },

  plan_analyse_desc: {
    en: "Together, we will analyse results and processes weekly to assess, tweak, and improve. This way, we can ensure you're heading in the right direction.",
    de: 'Gemeinsam analysieren wir wöchentlich Ergebnisse und Prozesse, um sie zu bewerten, anzupassen und zu verbessern. So stellen wir sicher, dass ihr in die richtige Richtung geht.',
  },

  plan_reset: {
    en: 'All token balances reset every month.',
    de: 'Alle Token-Guthaben werden jeden Monat zurückgesetzt.',
  },

  pricing_btn: {
    en: 'Start now',
    de: 'Jetzt starten',
  },

  Month: {
    en: 'Month',
    de: 'Monat',
  },

  Year: {
    en: 'Year',
    de: 'Jahr',
  },

  'Contact us': {
    en: 'Contact us',
    de: 'Kontakt',
  },

  Individuell: {
    en: 'Individuell',
    de: 'Individuell',
  },

  Growth: {
    en: 'Growth',
    de: 'Wachstum',
  },

  Users: {
    en: 'Users',
    de: 'Nutzer',
  },

  'Generator Tokens': {
    en: 'Generator Tokens',
    de: 'Generator-Tokens',
  },

  'Email Tokens': {
    en: 'Email Tokens',
    de: 'E-Mail-Tokens',
  },

  'Tracking Functionality': {
    en: 'Tracking Functionality',
    de: 'Tracking-Funktionalität',
  },

  'Connect via SMTP': {
    en: 'Connect via SMTP',
    de: 'Verbinden via SMTP',
  },

  'IMAP Tracking': {
    en: 'IMAP Tracking',
    de: 'IMAP-Tracking',
  },

  'Smart Inbox Rotate': {
    en: 'Smart Inbox Rotate',
    de: 'Intelligente Postfachrotation',
  },

  'API Access': {
    en: 'API Access',
    de: 'API-Zugriff',
  },

  Price: {
    en: 'Price',
    de: 'Preis',
  },

  '€100 / Month': {
    en: '€100 / Month',
    de: '100 € / Monat',
  },

  '€1.000 / Year': {
    en: '€1,000 / Year',
    de: '1.000 € / Jahr',
  },

  Deliverability: {
    en: 'Deliverability',
    de: 'Zustellbarkeit',
  },
}
